var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "bg-white md__card--holder" },
    [
      _c("user-picker-modal", {
        attrs: {
          visible: _vm.modals.contributors,
          "modal-title": "Key People",
          role: "CONTRIBUTOR",
          multi: true,
          skipList: _vm.skipList,
          saveOnUserSelect: false,
        },
        on: {
          input: _vm._onContributerUsersChanged,
          closeClicked: function ($event) {
            _vm.modals.contributors = false
          },
        },
        model: {
          value: _vm.contributors,
          callback: function ($$v) {
            _vm.contributors = $$v
          },
          expression: "contributors",
        },
      }),
      _c("user-picker-modal", {
        attrs: {
          visible: _vm.modals.viewers,
          "modal-title": "Viewers",
          role: "VIEWER",
          multi: true,
          skipList: _vm.skipList,
          saveOnUserSelect: false,
        },
        on: {
          input: _vm._onViewersChanged,
          closeClicked: function ($event) {
            _vm.modals.viewers = false
          },
        },
        model: {
          value: _vm.viewers,
          callback: function ($$v) {
            _vm.viewers = $$v
          },
          expression: "viewers",
        },
      }),
      _c("user-picker-modal", {
        attrs: {
          visible: _vm.modals.commentViewers,
          "modal-title": "Viewers For this activity",
          role: "VIEWER",
          multi: true,
          skipList: _vm.skipList,
          saveOnUserSelect: false,
        },
        on: {
          input: _vm._onCommentViewersChanged,
          closeClicked: function ($event) {
            _vm.modals.commentViewers = false
          },
        },
        model: {
          value: _vm.viewers,
          callback: function ($$v) {
            _vm.viewers = $$v
          },
          expression: "viewers",
        },
      }),
      _vm.lightbox.images && _vm.lightbox.images.length > 0
        ? _c("LightBox", {
            ref: "lb",
            attrs: { showLightBox: false, media: _vm.lightbox.images },
          })
        : _vm._e(),
      _c("UserPickerModal", {
        attrs: {
          visible: _vm.modals.assignedBy,
          title: "Assigned By",
          role: "CREATOR",
          multi: false,
        },
        on: {
          okClicked: _vm._onAssignedByUsersChanged,
          closeClicked: function ($event) {
            _vm.modals.assignedBy = false
          },
        },
        model: {
          value: _vm.task.assignedBy,
          callback: function ($$v) {
            _vm.$set(_vm.task, "assignedBy", $$v)
          },
          expression: "task.assignedBy",
        },
      }),
      _c("UserPickerModal", {
        attrs: {
          visible: _vm.modals.assignedTo,
          title: "Assigned To",
          role: "ASSIGNEE",
          multi: false,
        },
        on: {
          okClicked: _vm._onAssignedToUsersChanged,
          closeClicked: function ($event) {
            _vm.modals.assignedTo = false
          },
        },
        model: {
          value: _vm.task.assignedTo,
          callback: function ($$v) {
            _vm.$set(_vm.task, "assignedTo", $$v)
          },
          expression: "task.assignedTo",
        },
      }),
      _c("UserPickerModal", {
        attrs: {
          visible: _vm.modals.cc,
          title: "Search to add or invite someone to this Bracket",
          role: "CC",
          multi: true,
        },
        on: {
          okClicked: _vm._onCCUsersChanged,
          closeClicked: function ($event) {
            _vm.modals.cc = false
          },
        },
        model: {
          value: _vm.task.cc,
          callback: function ($$v) {
            _vm.$set(_vm.task, "cc", $$v)
          },
          expression: "task.cc",
        },
      }),
      _c("UserPickerModal", {
        attrs: {
          visible: _vm.modals.csu,
          title: "CSU To Client",
          role: "CLIENT",
          multi: true,
        },
        on: {
          okClicked: _vm._onCSUUsersChanged,
          closeClicked: function ($event) {
            _vm.modals.csu = false
          },
        },
        model: {
          value: _vm.task.csu,
          callback: function ($$v) {
            _vm.$set(_vm.task, "csu", $$v)
          },
          expression: "task.csu",
        },
      }),
      _c(
        "div",
        {
          staticClass: "card border-0 chat-bar d-flex flex-column shadow-none",
        },
        [
          _c(
            "div",
            {
              staticClass:
                "c-aside-header d-flex align-items-center bg-white position-relative",
            },
            [
              _c("div", { staticClass: "c-aside-header__title" }, [
                _c("div", {
                  staticClass: "c-aside-header__title-txt h6 mb-0",
                  staticStyle: { "min-width": "30px" },
                  attrs: { contenteditable: _vm.canEdit },
                  domProps: { innerHTML: _vm._s(_vm.editTitle) },
                  on: {
                    keypress: function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      )
                        return null
                      $event.preventDefault()
                      return _vm.onTitleChanged($event)
                    },
                    blur: function ($event) {
                      return _vm.onTitleChanged($event)
                    },
                    focus: _vm._onTitleFocusClicked,
                  },
                }),
              ]),
              _c(
                "ul",
                {
                  staticClass:
                    "c-aside-header__options d-flex mb-0 ml-auto pl-0 align-items-center",
                },
                [
                  _c(
                    "li",
                    {
                      staticClass:
                        "c-aside-header__options-list text-center d-inline-flex justify-content-center align-items-center",
                    },
                    [
                      _c("user-avatar", {
                        attrs: { data: _vm.task.assignedBy, disableEdit: true },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "li",
                    {
                      staticClass:
                        "c-aside-header__options-list text-center d-inline-flex justify-content-center align-items-center",
                    },
                    [
                      _c(
                        "a",
                        {
                          staticClass:
                            "c-aside-header__options-key d-inline-flex icn-notification position-relative",
                          attrs: { href: "javascript:void(0);" },
                          on: {
                            click: function ($event) {
                              _vm.modals.contributors = true
                            },
                          },
                        },
                        [
                          _c(
                            "span",
                            {
                              staticClass: "icn-svg icn-key lh-1",
                              attrs: { "data-v-1ecabc7e": "" },
                            },
                            [
                              _c(
                                "svg",
                                {
                                  staticClass: "icn-svg-full",
                                  attrs: {
                                    "data-v-1ecabc7e": "",
                                    xmlns: "http://www.w3.org/2000/svg",
                                    x: "0",
                                    y: "0",
                                    viewBox: "0 0 22.1 22.3",
                                    "xml:space": "preserve",
                                  },
                                },
                                [
                                  _c("path", {
                                    attrs: {
                                      "data-v-1ecabc7e": "",
                                      fill: "#2dce89",
                                      d: "M14 9.3c.6-2.1.3-4.3-.9-6.1C11.9 1.4 10 .2 7.8 0 5.7-.2 3.6.6 2.1 2.1S-.2 5.8 0 7.9C.2 10 1.3 12 3.1 13.2c1.8 1.2 4 1.5 6 .9l2.7 2.7c.1.1.3.2.5.2h1.9v2c0 .2.1.3.2.5.1.1.3.2.5.2h1.9v2c0 .2.1.3.2.5.1.1.3.2.5.2h3.9c.2 0 .3-.1.5-.2.1-.1.2-.3.2-.5v-3.9c0-.2-.1-.3-.2-.5l-7.9-8zM20.8 21h-2.6v-2c0-.2-.1-.3-.2-.5-.1-.1-.3-.2-.5-.2h-1.9v-2c0-.2-.1-.3-.2-.5-.1-.1-.3-.2-.5-.2h-2.3l-2.8-2.8c-.2-.2-.4-.2-.7-.2-1.7.6-3.5.4-5.1-.5-1.5-.9-2.5-2.5-2.7-4.3C1.1 6.1 1.8 4.3 3 3s3-1.9 4.8-1.7c1.8.2 3.4 1.2 4.3 2.8.9 1.5 1.1 3.4.5 5.1-.1.2 0 .5.2.7l8 8.1v3z",
                                    },
                                  }),
                                  _c("path", {
                                    attrs: {
                                      "data-v-1ecabc7e": "",
                                      fill: "#2dce89",
                                      d: "M4.3 4.7c-.4.4-.6.9-.6 1.5s.2 1.1.7 1.5c.4.4 1 .6 1.6.6.6 0 1.1-.2 1.6-.6.4-.4.7-.9.7-1.5s-.4-1.1-.8-1.5c-.5-.4-1-.6-1.6-.6-.6 0-1.1.2-1.6.6zm2.1 2c-.3.3-.7.3-1 0-.3-.3-.3-.7 0-1 .1-.1.3-.2.5-.2s.4.1.5.2c.2.1.2.3.2.5s0 .4-.2.5z",
                                    },
                                  }),
                                ]
                              ),
                            ]
                          ),
                          _c(
                            "span",
                            {
                              staticClass: "icn-badge bg-success",
                              attrs: { "data-v-1ecabc7e": "" },
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.task &&
                                    _vm.task.contributors &&
                                    _vm.task.contributors.length
                                )
                              ),
                            ]
                          ),
                        ]
                      ),
                    ]
                  ),
                  _c(
                    "li",
                    {
                      staticClass:
                        "c-aside-header__options-list text-center d-inline-flex justify-content-center align-items-center",
                    },
                    [
                      _c(
                        "a",
                        {
                          staticClass:
                            "c-aside-header__options-eye d-inline-flex icn-notification position-relative",
                          attrs: { href: "javascript:void((0);" },
                          on: {
                            click: function ($event) {
                              _vm.modals.viewers = true
                            },
                          },
                        },
                        [
                          _c("span", { staticClass: "icn-svg icn-eye lh-1" }, [
                            _c(
                              "svg",
                              {
                                staticClass: "icn-svg-full",
                                attrs: {
                                  "data-v-1ecabc7e": "",
                                  xmlns: "http://www.w3.org/2000/svg",
                                  x: "0",
                                  y: "0",
                                  viewBox: "0 0 28.1 18.2",
                                  "xml:space": "preserve",
                                },
                              },
                              [
                                _c("path", {
                                  attrs: {
                                    "data-v-1ecabc7e": "",
                                    fill: "#fb6340",
                                    d: "M14.3 18.2c4.8 0 9.5-3 13.7-8.8.1-.2.2-.5 0-.7-.2-.3-5.8-8.5-13.9-8.7C9.2-.1 4.5 2.8.1 8.7c-.1.2-.1.5 0 .7.2.4 5.8 8.7 13.9 8.9.1-.1.2-.1.3-.1zm12.5-9.1c-4 5.4-8.3 8.1-12.7 8-6.5-.1-11.5-6.4-12.7-8 4-5.3 8.3-7.9 12.7-7.9 6.5.2 11.5 6.3 12.7 7.9z",
                                  },
                                }),
                                _c("path", {
                                  attrs: {
                                    "data-v-1ecabc7e": "",
                                    fill: "#fb6340",
                                    d: "M14.1 14.1c1.3 0 2.6-.5 3.6-1.5.9-.9 1.5-2.2 1.5-3.5 0-1.3-.5-2.6-1.5-3.5-.9-.9-2.2-1.5-3.6-1.5s-2.6.5-3.6 1.5C9.6 6.5 9 7.8 9 9.1c0 1.3.5 2.6 1.5 3.5.9 1 2.2 1.5 3.6 1.5zm0-8.7c1 0 2 .4 2.7 1.1.7.7 1.1 1.7 1.1 2.7s-.4 2-1.1 2.7c-.7.7-1.7 1.1-2.7 1.1s-2-.4-2.7-1.1c-.7-.7-1.1-1.7-1.1-2.7 0-1 .4-2 1.1-2.7.7-.7 1.7-1.1 2.7-1.1z",
                                  },
                                }),
                              ]
                            ),
                          ]),
                          _c(
                            "span",
                            {
                              staticClass: "icn-badge bg-alert",
                              attrs: { "data-v-1ecabc7e": "" },
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.task &&
                                    _vm.task.viewers &&
                                    _vm.task.viewers.length
                                )
                              ),
                            ]
                          ),
                        ]
                      ),
                    ]
                  ),
                ]
              ),
              _c(
                "div",
                {
                  staticClass:
                    "c-aside-header__options-close d-flex position-absolute justify-content-center align-items-center",
                },
                [
                  _c(
                    "button",
                    {
                      staticClass: "close close--custom-one",
                      attrs: {
                        type: "button",
                        "data-dismiss": "modal",
                        "aria-label": "Close",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.$emit("closeClick")
                        },
                      },
                    },
                    [
                      _c(
                        "span",
                        {
                          staticClass: "icn-svg icn-close lh-1",
                          attrs: { "aria-hidden": "true" },
                        },
                        [
                          _c(
                            "svg",
                            {
                              staticClass: "icn-svg-full",
                              attrs: {
                                xmlns: "http://www.w3.org/2000/svg",
                                viewBox: "0 0 24 25.3",
                                "xml:space": "preserve",
                              },
                            },
                            [
                              _c("path", {
                                attrs: {
                                  d: "m13.9 12.6 9.8-10.3c.5-.5.5-1.4 0-2-.5-.6-1.3-.5-1.9 0L12 10.7 2.3.4C1.8-.1 1-.1.4.4s-.5 1.4 0 2l9.8 10.3L.4 22.9c-.5.5-.5 1.4 0 2 .3.3.6.4.9.4.3 0 .7-.1.9-.4L12 14.6l9.8 10.3c.3.3.6.4.9.4.3 0 .7-.1.9-.4.5-.5.5-1.4 0-2l-9.7-10.3z",
                                },
                              }),
                            ]
                          ),
                        ]
                      ),
                    ]
                  ),
                ]
              ),
            ]
          ),
          _c("div", { staticClass: "c-aside-detail" }, [
            _c(
              "div",
              { staticClass: "c-aside-detail__head d-flex align-items-center" },
              [
                _c("div", { staticClass: "c-aside-detail__user" }, [
                  _c("div", { staticClass: "d-flex" }, [
                    _c(
                      "div",
                      [
                        _c("user-avatar", {
                          attrs: {
                            data: _vm.task.assignedBy,
                            disableEdit: true,
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "d-flex flex-column justify-content-center ml-2",
                      },
                      [
                        _c("h6", { staticClass: "mb-0 text-sm lh-1 mb-1" }, [
                          _vm._v(_vm._s(_vm.assignedByName)),
                        ]),
                        _c(
                          "span",
                          { staticClass: "text-xs text-muted mb-0 lh-1" },
                          [_vm._v(_vm._s(_vm.createdDate))]
                        ),
                      ]
                    ),
                  ]),
                ]),
                _c("div", { staticClass: "c-aside-detail__info ml-auto" }, [
                  _c(
                    "ul",
                    { staticClass: "c-aside-timeline d-flex pl-0 mb-0" },
                    [
                      _c("li", { staticClass: "c-aside-timeline__list mx-3" }, [
                        _c(
                          "div",
                          {
                            staticClass:
                              "d-flex flex-row align-items-center h-100",
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "c-aside-timeline__list-item h-auto d-flex flex-column justify-content-center",
                              },
                              [
                                _c(
                                  "small",
                                  {
                                    staticClass:
                                      "c-aside-timeline__list-title small-54 ltr-sp-4 text-muted font-weight-bold text-uppercase lh-1 mb-1",
                                  },
                                  [
                                    _vm._v(
                                      "\n                    Due Date\n                  "
                                    ),
                                  ]
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "c-aside-timeline__list-duration text-xs text-alert lh-1",
                                  },
                                  [
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(_vm.dueDate) +
                                        "\n                  "
                                    ),
                                  ]
                                ),
                              ]
                            ),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "c-aside-timeline__list-icon lh-1 ml-2",
                              },
                              [
                                _c(
                                  "span",
                                  { staticClass: "icn-svg icn-calender" },
                                  [
                                    _c(
                                      "svg",
                                      {
                                        staticClass: "icn-svg-full",
                                        staticStyle: {
                                          "enable-background":
                                            "new 0 0 14.1 14.3",
                                        },
                                        attrs: {
                                          xmlns: "http://www.w3.org/2000/svg",
                                          x: "0",
                                          y: "0",
                                          viewBox: "0 0 14.1 14.3",
                                          "xml:space": "preserve",
                                        },
                                      },
                                      [
                                        _c("path", {
                                          attrs: {
                                            fill: "#8898aa",
                                            d: "M2.1 12.6h2.3c.1 0 .1 0 .2-.1 0 0 .1-.1.1-.2v-2c0-.1 0-.1-.1-.2 0 0-.1-.1-.2-.1H2.1c-.1 0-.1 0-.2.1 0 0-.1.1-.1.2v2c0 .1 0 .1.1.2s.1.1.2.1zM2.1 9.1h2.3c.1 0 .1 0 .2-.1 0 0 .1-.1.1-.2v-2c0-.1 0-.1-.1-.2 0 0-.1-.1-.2-.1H2.1c-.1.2-.1.2-.2.2 0 0-.1.1-.1.2v2c0 .1 0 .1.1.2h.2zM5.9 12.6h2.3c.1 0 .1 0 .2-.1 0 0 .1-.1.1-.2v-2c0-.1 0-.1-.1-.2 0 0-.1-.1-.2-.1H5.9c-.1 0-.1 0-.2.1 0 0-.1.1-.1.2v2c0 .1 0 .1.1.2 0 .1.1.1.2.1zM5.9 9.1h2.3c.1 0 .1 0 .2-.1 0 0 .1-.1.1-.2v-2c0-.1 0-.1-.1-.2 0 0-.1-.1-.2-.1H5.9c-.1 0-.1 0-.2.1 0 0-.1.1-.1.2v2c0 .1 0 .1.1.2 0 .1.1.1.2.1zM9.6 9.1H12c.1 0 .1 0 .2-.1 0 0 .1-.1.1-.2v-2c0-.1 0-.1-.1-.2 0 0-.1-.1-.2-.1H9.6c-.1 0-.1 0-.2.1 0 0-.1.1-.1.2v2c0 .1 0 .1.1.2s.1.1.2.1zM3.3 3.5c-.1 0-.1 0-.2-.1 0 0-.1-.1-.1-.2v-3c0-.1 0-.1.1-.2h.2c.1 0 .1 0 .2.1 0 0 .1.1.1.2v3c0 .1 0 .1-.1.2-.1-.1-.2 0-.2 0z",
                                          },
                                        }),
                                        _c("path", {
                                          attrs: {
                                            fill: "#8898aa",
                                            d: "M13.4 1.5h-1.9v1.7c0 .2-.1.4-.2.5-.1.1-.3.2-.5.2s-.4-.1-.5-.2c-.1-.1-.2-.3-.2-.5V1.5H4v1.7c0 .2-.1.4-.2.5-.2.2-.3.2-.5.2s-.4 0-.5-.2c-.1-.1-.2-.3-.2-.5V1.5H.7c-.2 0-.4.1-.5.2-.1.1-.2.3-.2.5v11.4c0 .2.1.4.2.5.1.1.3.2.5.2h12.7c.2 0 .4-.1.5-.2.1-.1.2-.3.2-.5V2.2c0-.2-.1-.4-.2-.5-.2-.1-.4-.2-.5-.2zm.2 12.1c0 .1 0 .1-.1.2 0 0-.1.1-.2.1H.7c-.1 0-.1 0-.2-.1 0 0-.1-.1-.1-.2V5.4h13.1v8.2z",
                                          },
                                        }),
                                        _c("path", {
                                          attrs: {
                                            fill: "#8898aa",
                                            d: "M10.8 3.5c-.1 0-.1 0-.2-.1 0 0-.1-.1-.1-.2v-3c0-.1 0-.1.1-.2 0 0 .1-.1.2-.1s.1 0 .2.1c0 0 .1.1.1.2v3c0 .1 0 .1-.1.2-.1 0-.2.1-.2.1z",
                                          },
                                        }),
                                      ]
                                    ),
                                  ]
                                ),
                              ]
                            ),
                          ]
                        ),
                      ]),
                      _c("li", { staticClass: "c-aside-timeline__list mx-3" }, [
                        _c(
                          "div",
                          {
                            staticClass:
                              "d-flex flex-row align-items-center h-100",
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "c-aside-timeline__list-item h-auto d-flex flex-column justify-content-center",
                              },
                              [
                                _c(
                                  "small",
                                  {
                                    staticClass:
                                      "c-aside-timeline__list-title small-54 ltr-sp-4 text-muted font-weight-bold text-uppercase lh-1 mb-1",
                                  },
                                  [
                                    _vm._v(
                                      "\n                    Time\n                  "
                                    ),
                                  ]
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "c-aside-timeline__list-duration text-xs text-alert lh-1",
                                  },
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "badge badge-sm badge-warning badge--custom-one mr-2",
                                      },
                                      [_vm._v(_vm._s(_vm.workedHours))]
                                    ),
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "badge badge-sm badge-alert badge--custom-one",
                                      },
                                      [_vm._v(_vm._s(_vm.task.quoted_hours))]
                                    ),
                                  ]
                                ),
                              ]
                            ),
                          ]
                        ),
                      ]),
                    ]
                  ),
                ]),
                _c(
                  "div",
                  { staticClass: "c-aside-detail__toggle-btn" },
                  [
                    _c(
                      "base-dropdown",
                      {
                        staticClass: "dropdown--dot",
                        attrs: {
                          "has-toggle": false,
                          "title-classes":
                            "btn btn-dot-action text-default border-0  mb-0 mr-0",
                          "menu-on-right": "",
                        },
                      },
                      [
                        _c("template", { slot: "title" }, [
                          _c("i", { staticClass: "fas fa-ellipsis-v text-xs" }),
                        ]),
                        _c("div", { staticClass: "d-flex w-100" }, [
                          _c(
                            "a",
                            {
                              staticClass:
                                "dropdown-item d-flex alig-items-center lh-1",
                              attrs: { href: "javascript:void(0);" },
                              on: {
                                click: function ($event) {
                                  return _vm._onDeleteTaskClicked(_vm.task)
                                },
                              },
                            },
                            [_vm._v("\n                Delete")]
                          ),
                        ]),
                      ],
                      2
                    ),
                  ],
                  1
                ),
              ]
            ),
            _c("div", { staticClass: "c-aside-detail__body bg-light-grey" }, [
              _c("div", { staticClass: "c-aside-detail__toggle" }, [
                _c("div", { staticClass: "c-aside-detail__content" }, [
                  _c("p", {
                    staticClass: "font-weight-bold text-primary",
                    domProps: {
                      innerHTML: _vm._s(
                        _vm.task.comments && _vm.task.comments.length > 0
                          ? _vm.task.comments[0].description
                          : _vm.task.description
                      ),
                    },
                  }),
                ]),
                _c("div", { staticClass: "c-aside-detail__img" }, [
                  _vm.task.comments &&
                  _vm.task.comments.length > 0 &&
                  _vm.task.comments[0].attachments.length > 0
                    ? _c("img", {
                        staticClass: "w-100",
                        attrs: {
                          src: _vm.task.comments[0].attachments[0].file_url,
                        },
                      })
                    : _vm._e(),
                ]),
              ]),
              _c("div", { staticClass: "c-aside-detail__filter d-flex" }, [
                _c(
                  "div",
                  { staticClass: "c-aside-detail__filter-title text-success" },
                  [_vm._v("\n            Activity {\n          ")]
                ),
                _c(
                  "div",
                  {
                    staticClass:
                      "c-aside-detail__filter-icon ml-auto d-inline-flex align-items-center",
                  },
                  [
                    _c("span", { staticClass: "icn-svg icn-filter" }, [
                      _c(
                        "svg",
                        {
                          staticClass: "icn-svg-full",
                          staticStyle: {
                            "enable-background": "new 0 0 12.1 16.1",
                          },
                          attrs: {
                            xmlns: "http://www.w3.org/2000/svg",
                            viewBox: "0 0 12.1 16.1",
                            "xml:space": "preserve",
                          },
                        },
                        [
                          _c("path", {
                            attrs: {
                              d: "M3 9V0H2v9c-1.1.2-2 1.2-2 2.5 0 1.2.9 2.2 2 2.5v2.2h1V14c1.1-.2 2-1.2 2-2.5S4.1 9.2 3 9zm0 3.9c-.2 0-.3.1-.5.1s-.3 0-.5-.1c-.6-.2-1-.8-1-1.4 0-.6.4-1.2 1-1.4.2-.1.3-.1.5-.1H3c.6.2 1 .8 1 1.4 0 .7-.4 1.3-1 1.5zM12.1 4.7c0-1.2-.9-2.2-2-2.5V0h-1v2.2c-1.1.2-2 1.2-2 2.5 0 1.2.9 2.2 2 2.5v9h1v-9c1.1-.3 2-1.3 2-2.5zm-1 0c0 .6-.4 1.2-1 1.4-.2 0-.3.1-.5.1s-.3 0-.5-.1c-.6-.2-1-.8-1-1.4 0-.7.4-1.2 1-1.4.2-.1.3-.1.5-.1s.3 0 .5.1c.6.2 1 .7 1 1.4z",
                            },
                          }),
                        ]
                      ),
                    ]),
                  ]
                ),
              ]),
            ]),
          ]),
          _c("div", { staticClass: "c-aside-chat" }, [
            _c("div", { staticClass: "c-aside-chat__wrap" }, [
              !_vm.task.comments ||
              (_vm.task.comments && _vm.task.comments.length <= 1)
                ? _c("p", { staticClass: "no-message" }, [
                    _vm._v(
                      "\n          Leave a Message to Start a Conversation.\n        "
                    ),
                  ])
                : _vm._e(),
              _c(
                "ul",
                {
                  staticClass:
                    "c-aside-chat__list list-unstyled d-flex flex-column mb-0",
                },
                _vm._l(_vm.task.comments, function (comment, ind) {
                  return _c(
                    "li",
                    {
                      key: ind,
                      staticClass: "c-aside-chat__items",
                      class: {
                        "user-you": comment.from_user.user.id == _vm.profile.id,
                        "user-1": comment.from_user.user.id != _vm.profile.id,
                      },
                    },
                    [
                      ind > 0
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "c-aside-chat__block position-relative",
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "c-aside-chat__avatar" },
                                [
                                  _c("user-avatar", {
                                    attrs: {
                                      data: comment.from_user,
                                      disableEdit: true,
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "c-aside-chat__content position-relative",
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "c-aside-chat__content-name",
                                    },
                                    [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(
                                            comment.from_user.user.first_name +
                                              " " +
                                              comment.from_user.user.first_name
                                          ) +
                                          "\n                "
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "c-aside-chat__content-date text-primary",
                                    },
                                    [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(comment.age) +
                                          "\n                "
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "c-aside-chat__content-para position-relative",
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "c-aside-chat__content-text",
                                        },
                                        [
                                          _c("p", [
                                            _vm._v(
                                              "\n                      " +
                                                _vm._s(comment.description) +
                                                "\n                    "
                                            ),
                                          ]),
                                          _vm._l(
                                            comment.attachments,
                                            function (att, i) {
                                              return _c("img", {
                                                key: i,
                                                staticClass:
                                                  "image-reply text-img",
                                                attrs: {
                                                  src: att.file_url,
                                                  alt: att.file_url,
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm._onAttachmentClicked(
                                                      att
                                                    )
                                                  },
                                                },
                                              })
                                            }
                                          ),
                                        ],
                                        2
                                      ),
                                      comment.from_user.user.id ==
                                      _vm.profile.id
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "c-aside-chat__content-eye d-inline-block icn-notification position-absolute",
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "icn-svg icn-eye lh-1",
                                                },
                                                [
                                                  _c(
                                                    "svg",
                                                    {
                                                      staticClass:
                                                        "icn-svg-full",
                                                      attrs: {
                                                        xmlns:
                                                          "http://www.w3.org/2000/svg",
                                                        x: "0",
                                                        y: "0",
                                                        viewBox:
                                                          "0 0 28.1 18.2",
                                                        "xml:space": "preserve",
                                                      },
                                                    },
                                                    [
                                                      _c("path", {
                                                        attrs: {
                                                          fill: "#CED4DA",
                                                          d: "M14.3 18.2c4.8 0 9.5-3 13.7-8.8.1-.2.2-.5 0-.7-.2-.3-5.8-8.5-13.9-8.7C9.2-.1 4.5 2.8.1 8.7c-.1.2-.1.5 0 .7.2.4 5.8 8.7 13.9 8.9.1-.1.2-.1.3-.1zm12.5-9.1c-4 5.4-8.3 8.1-12.7 8-6.5-.1-11.5-6.4-12.7-8 4-5.3 8.3-7.9 12.7-7.9 6.5.2 11.5 6.3 12.7 7.9z",
                                                        },
                                                      }),
                                                      _c("path", {
                                                        attrs: {
                                                          fill: "#CED4DA",
                                                          d: "M14.1 14.1c1.3 0 2.6-.5 3.6-1.5.9-.9 1.5-2.2 1.5-3.5 0-1.3-.5-2.6-1.5-3.5-.9-.9-2.2-1.5-3.6-1.5s-2.6.5-3.6 1.5C9.6 6.5 9 7.8 9 9.1c0 1.3.5 2.6 1.5 3.5.9 1 2.2 1.5 3.6 1.5zm0-8.7c1 0 2 .4 2.7 1.1.7.7 1.1 1.7 1.1 2.7s-.4 2-1.1 2.7c-.7.7-1.7 1.1-2.7 1.1s-2-.4-2.7-1.1c-.7-.7-1.1-1.7-1.1-2.7 0-1 .4-2 1.1-2.7.7-.7 1.7-1.1 2.7-1.1z",
                                                        },
                                                      }),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "icn-badge bg-light-1 text-white",
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      (comment.viewers &&
                                                        comment.viewers
                                                          .length) ||
                                                        0
                                                    )
                                                  ),
                                                ]
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          )
                        : _vm._e(),
                    ]
                  )
                }),
                0
              ),
            ]),
            _c(
              "div",
              { staticClass: "tf__attachment-box" },
              [
                _vm._l(_vm.attachments, function (file, ind) {
                  return _c(
                    "div",
                    { key: ind, staticClass: "tf__content-box" },
                    [
                      _c(
                        "a",
                        {
                          staticClass: "tf__c-b--close",
                          attrs: { href: "javascript:void(0)" },
                          on: {
                            click: function ($event) {
                              return _vm._onDeleteAttachment(file)
                            },
                          },
                        },
                        [_c("i", { staticClass: "fas fa-times" })]
                      ),
                      file.content_type.includes("image")
                        ? _c("div", { staticClass: "image" }, [
                            _c("img", { attrs: { src: file.file_url } }),
                            _c("div", { staticClass: "tf__c-b--filename" }, [
                              _vm._v(
                                "\n              " +
                                  _vm._s(file.user_file_name) +
                                  "\n            "
                              ),
                            ]),
                          ])
                        : _c("div", { staticClass: "file" }, [
                            _vm._m(0, true),
                            _c("div", { staticClass: "tf__c-b--filename" }, [
                              _vm._v(
                                "\n              " +
                                  _vm._s(file.user_file_name) +
                                  "\n            "
                              ),
                            ]),
                          ]),
                    ]
                  )
                }),
                _vm.uploading
                  ? _c("div", { staticClass: "tf__content-box" }, [_vm._m(1)])
                  : _vm._e(),
              ],
              2
            ),
            _c("div", { staticClass: "c-aside-chat__msg" }, [
              _c(
                "div",
                { staticClass: "c-aside-chat__msg-wrap position-relative" },
                [
                  _c(
                    "div",
                    {
                      staticClass: "c-aside-chat__msg-avatar position-absolute",
                    },
                    [
                      _c("user-avatar", {
                        attrs: {
                          data: { user: _vm.profile },
                          disableEdit: true,
                        },
                      }),
                    ],
                    1
                  ),
                  _c("div", { staticClass: "c-aside-chat__msg-content" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "input-group c-aside-chat__msg-input-grp position-relative",
                      },
                      [
                        _vm.canComment
                          ? _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.comment,
                                  expression: "comment",
                                },
                              ],
                              staticClass:
                                "form-control c-aside-chat__msg-input-txt",
                              attrs: {
                                type: "text",
                                placeholder: "Write your comment",
                                "aria-label": "Recipient's username",
                                "aria-describedby": "button-addon2",
                                rows: _vm.numLines,
                              },
                              domProps: { value: _vm.comment },
                              on: {
                                keydown: function ($event) {
                                  if (
                                    !$event.type.indexOf("key") &&
                                    _vm._k(
                                      $event.keyCode,
                                      "enter",
                                      13,
                                      $event.key,
                                      "Enter"
                                    )
                                  )
                                    return null
                                  if (
                                    $event.ctrlKey ||
                                    $event.shiftKey ||
                                    $event.altKey ||
                                    $event.metaKey
                                  )
                                    return null
                                  return _vm.handleSubmit.apply(null, arguments)
                                },
                                input: function ($event) {
                                  if ($event.target.composing) return
                                  _vm.comment = $event.target.value
                                },
                              },
                            })
                          : _vm._e(),
                        _c(
                          "div",
                          {
                            staticClass:
                              "input-group-append input-group-append--send position-absolute h-100",
                          },
                          [
                            _c(
                              "button",
                              {
                                staticClass:
                                  "btn d-flex align-items-center border-0 btn-send shadow-none",
                                attrs: { type: "button", id: "button-addon2" },
                              },
                              [
                                _c(
                                  "span",
                                  { staticClass: "icn-svg icn-send" },
                                  [
                                    _c(
                                      "svg",
                                      {
                                        staticClass: "icn-svg-full",
                                        staticStyle: {
                                          "enable-background":
                                            "new 0 0 512 512",
                                        },
                                        attrs: {
                                          xmlns: "http://www.w3.org/2000/svg",
                                          viewBox: "0 0 512 512",
                                          "xml:space": "preserve",
                                        },
                                      },
                                      [
                                        _c("path", {
                                          staticStyle: { fill: "#525f7f" },
                                          attrs: {
                                            d: "M507.6 4.4C503.4.2 497-1.1 491.4 1.1L9.4 193.9c-5.5 2.2-9.2 7.5-9.4 13.4-.2 5.9 3.1 11.4 8.4 14l190.1 92.2 92.2 190.1c2.5 5.2 7.8 8.5 13.5 8.5h.5c5.9-.2 11.2-3.9 13.4-9.4l192.8-482c2.3-5.7 1-12.1-3.3-16.3zM52.1 209.1l382.6-153-228 228-154.6-75zm250.8 250.8-75-154.6 228-228-153 382.6z",
                                          },
                                        }),
                                      ]
                                    ),
                                  ]
                                ),
                              ]
                            ),
                          ]
                        ),
                      ]
                    ),
                    _c(
                      "ul",
                      {
                        staticClass:
                          "c-aside-chat__msg-list list-unstyled d-flex flex-row mb-0 mt-4",
                      },
                      [
                        false
                          ? _c(
                              "li",
                              { staticClass: "c-aside-chat__msg-item" },
                              [
                                _c(
                                  "a",
                                  {
                                    staticClass:
                                      "c-aside-header__options-key d-inline-flex icn-notification position-relative",
                                    attrs: { href: "javascript:void();" },
                                  },
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticClass: "icn-svg icn-key lh-1",
                                        attrs: {
                                          "data-v-2c583648": "",
                                          "data-v-1ecabc7e": "",
                                        },
                                      },
                                      [
                                        _c(
                                          "svg",
                                          {
                                            staticClass: "icn-svg-full",
                                            attrs: {
                                              "data-v-2c583648": "",
                                              "data-v-1ecabc7e": "",
                                              xmlns:
                                                "http://www.w3.org/2000/svg",
                                              x: "0",
                                              y: "0",
                                              viewBox: "0 0 22.1 22.3",
                                              "xml:space": "preserve",
                                            },
                                          },
                                          [
                                            _c("path", {
                                              attrs: {
                                                "data-v-2c583648": "",
                                                "data-v-1ecabc7e": "",
                                                fill: "#2dce89",
                                                d: "M14 9.3c.6-2.1.3-4.3-.9-6.1C11.9 1.4 10 .2 7.8 0 5.7-.2 3.6.6 2.1 2.1S-.2 5.8 0 7.9C.2 10 1.3 12 3.1 13.2c1.8 1.2 4 1.5 6 .9l2.7 2.7c.1.1.3.2.5.2h1.9v2c0 .2.1.3.2.5.1.1.3.2.5.2h1.9v2c0 .2.1.3.2.5.1.1.3.2.5.2h3.9c.2 0 .3-.1.5-.2.1-.1.2-.3.2-.5v-3.9c0-.2-.1-.3-.2-.5l-7.9-8zM20.8 21h-2.6v-2c0-.2-.1-.3-.2-.5-.1-.1-.3-.2-.5-.2h-1.9v-2c0-.2-.1-.3-.2-.5-.1-.1-.3-.2-.5-.2h-2.3l-2.8-2.8c-.2-.2-.4-.2-.7-.2-1.7.6-3.5.4-5.1-.5-1.5-.9-2.5-2.5-2.7-4.3C1.1 6.1 1.8 4.3 3 3s3-1.9 4.8-1.7c1.8.2 3.4 1.2 4.3 2.8.9 1.5 1.1 3.4.5 5.1-.1.2 0 .5.2.7l8 8.1v3z",
                                              },
                                            }),
                                            _c("path", {
                                              attrs: {
                                                "data-v-2c583648": "",
                                                "data-v-1ecabc7e": "",
                                                fill: "#2dce89",
                                                d: "M4.3 4.7c-.4.4-.6.9-.6 1.5s.2 1.1.7 1.5c.4.4 1 .6 1.6.6.6 0 1.1-.2 1.6-.6.4-.4.7-.9.7-1.5s-.4-1.1-.8-1.5c-.5-.4-1-.6-1.6-.6-.6 0-1.1.2-1.6.6zm2.1 2c-.3.3-.7.3-1 0-.3-.3-.3-.7 0-1 .1-.1.3-.2.5-.2s.4.1.5.2c.2.1.2.3.2.5s0 .4-.2.5z",
                                              },
                                            }),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "span",
                                      {
                                        staticClass: "icn-badge bg-success",
                                        attrs: {
                                          "data-v-2c583648": "",
                                          "data-v-1ecabc7e": "",
                                        },
                                      },
                                      [_vm._v("1")]
                                    ),
                                  ]
                                ),
                              ]
                            )
                          : _vm._e(),
                        _c("li", { staticClass: "c-aside-chat__msg-item" }, [
                          _c(
                            "a",
                            {
                              staticClass:
                                "c-aside-header__options-key d-inline-block icn-notification position-relative",
                              attrs: { href: "javascript:void(0);" },
                              on: {
                                click: function ($event) {
                                  _vm.modals.commentViewers = true
                                },
                              },
                            },
                            [
                              _c(
                                "span",
                                { staticClass: "icn-svg icn-eye lh-1" },
                                [
                                  _c(
                                    "svg",
                                    {
                                      staticClass: "icn-svg-full",
                                      attrs: {
                                        xmlns: "http://www.w3.org/2000/svg",
                                        x: "0",
                                        y: "0",
                                        viewBox: "0 0 28.1 18.2",
                                        "xml:space": "preserve",
                                      },
                                    },
                                    [
                                      _c("path", {
                                        attrs: {
                                          fill: "#CED4DA",
                                          d: "M14.3 18.2c4.8 0 9.5-3 13.7-8.8.1-.2.2-.5 0-.7-.2-.3-5.8-8.5-13.9-8.7C9.2-.1 4.5 2.8.1 8.7c-.1.2-.1.5 0 .7.2.4 5.8 8.7 13.9 8.9.1-.1.2-.1.3-.1zm12.5-9.1c-4 5.4-8.3 8.1-12.7 8-6.5-.1-11.5-6.4-12.7-8 4-5.3 8.3-7.9 12.7-7.9 6.5.2 11.5 6.3 12.7 7.9z",
                                        },
                                      }),
                                      _c("path", {
                                        attrs: {
                                          fill: "#CED4DA",
                                          d: "M14.1 14.1c1.3 0 2.6-.5 3.6-1.5.9-.9 1.5-2.2 1.5-3.5 0-1.3-.5-2.6-1.5-3.5-.9-.9-2.2-1.5-3.6-1.5s-2.6.5-3.6 1.5C9.6 6.5 9 7.8 9 9.1c0 1.3.5 2.6 1.5 3.5.9 1 2.2 1.5 3.6 1.5zm0-8.7c1 0 2 .4 2.7 1.1.7.7 1.1 1.7 1.1 2.7s-.4 2-1.1 2.7c-.7.7-1.7 1.1-2.7 1.1s-2-.4-2.7-1.1c-.7-.7-1.1-1.7-1.1-2.7 0-1 .4-2 1.1-2.7.7-.7 1.7-1.1 2.7-1.1z",
                                        },
                                      }),
                                    ]
                                  ),
                                ]
                              ),
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "icn-badge bg-light-1 text-white",
                                },
                                [_vm._v(_vm._s(_vm.commentViewers.length || 0))]
                              ),
                            ]
                          ),
                        ]),
                        _c("li", { staticClass: "c-aside-chat__msg-item" }, [
                          _vm.canComment
                            ? _c(
                                "a",
                                {
                                  attrs: { href: "javascript:void(0)" },
                                  on: { click: _vm._onUploadClicked },
                                },
                                [
                                  _c(
                                    "span",
                                    { staticClass: "icn-svg icn-clip lh-1" },
                                    [
                                      _c(
                                        "svg",
                                        {
                                          staticClass: "icn-svg-full",
                                          staticStyle: {
                                            "enable-background":
                                              "new 0 0 21.4 20",
                                          },
                                          attrs: {
                                            xmlns: "http://www.w3.org/2000/svg",
                                            viewBox: "0 0 21.4 20",
                                            "xml:space": "preserve",
                                          },
                                        },
                                        [
                                          _c("path", {
                                            staticStyle: { fill: "#5e72e4" },
                                            attrs: {
                                              d: "M14.7 0c1.8 0 3.5.7 4.7 2.1 1.2 1.3 1.9 3 1.9 4.9 0 1.9-.7 3.7-1.9 5l-6.6 7c-.2.2-.4.3-.7.3-.3 0-.5-.1-.7-.3-.4-.4-.4-1.1 0-1.5l6.6-7c.9-.9 1.4-2.2 1.4-3.5 0-1.3-.5-2.5-1.4-3.4-1.8-1.9-4.9-1.9-6.6 0l-8.6 9.1c-1.1 1.2-1.1 3.1 0 4.3.5.6 1.2.9 2 .9s1.5-.3 2.1-.9l7.8-8.3c.2-.3.3-.6.3-.8 0-.3-.1-.5-.3-.7-.4-.4-1.1-.4-1.5 0L9.6 11c-.2.2-.4.3-.7.3-.3 0-.5-.1-.7-.3-.4-.4-.4-1.1 0-1.5l3.7-3.9c1.1-1.2 3.1-1.2 4.2 0 .6.6.9 1.4.9 2.2 0 .8-.3 1.6-.8 2.2v.1l-7.9 8.4c-.9 1-2.1 1.5-3.4 1.5-1.3 0-2.5-.6-3.4-1.5-1.9-2-1.9-5.2 0-7.2L10 2.1C11.3.7 12.9 0 14.7 0z",
                                            },
                                          }),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ]),
                      ]
                    ),
                    _c(
                      "div",
                      { staticClass: "chat-box__subtext" },
                      [
                        _c(
                          "vue-clip",
                          {
                            attrs: {
                              options: _vm.dropzoneOptions,
                              "on-removed-file": _vm._onFileRemoved,
                              "on-complete": _vm._onComplete,
                              "on-added-file": _vm._onFileAdded,
                            },
                          },
                          [
                            _c("template", { slot: "clip-uploader-action" }, [
                              _c("div", [
                                _c("div", { staticClass: "dz-message" }),
                              ]),
                            ]),
                            _c("template", { slot: "clip-uploader-body" }),
                          ],
                          2
                        ),
                      ],
                      1
                    ),
                  ]),
                ]
              ),
            ]),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "tf__c-b--file" }, [
      _c("img", {
        attrs: { src: require("@/assets/img/icons/svgs/solid/arrowLeft.svg") },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "loading" }, [
      _c("i", { staticClass: "fas fa-spinner fa-pulse" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }